import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
// import DarkModeBtn from '../components/DarkModeBtn';
// import { useUser } from '../contexts/UserContext';
import LogoutButton from '../components/LogoutButton';
import BuyModal from '../components/BuyModal';
import DepositModal from '../components/DepositModal';
import UserActionsBar from '../components/UserActionsBar';
const ProptTokens = () => {
   // Hooks y estados
   const [rates, setRates] = useState(null);
   const [isLoading, setIsLoading] = useState(true);
   const [error, setError] = useState(null);
   // const { userEmail, userName } = useUser();
   const [isDepositModalOpen, setIsDepositModalOpen] = useState(false);
   const [isBuyModalOpen, setIsBuyModalOpen] = useState(false);
   const [selectedCrypto, setSelectedCrypto] = useState(null);
   const [initialStep, setInitialStep] = useState(1);
   const [selectedCryptoForBuy, setSelectedCryptoForBuy] = useState(null);
   // Handlers para modales
   // const handleDepositClick = (cryptoName, symbol) => {
   //    setSelectedCrypto({
   //       name: cryptoName,
   //       currency: symbol
   //    });
   //    setInitialStep(3);
   //    setIsDepositModalOpen(true);
   // };
   // const handleBuyClick = (cryptoName, symbol) => {
   //    setSelectedCryptoForBuy({
   //       name: cryptoName,
   //       currency: symbol
   //    });
   //    setIsBuyModalOpen(true);
   // };
   useEffect(() => {
      // La lógica de la API ahora vive aquí adentro
      const fetchRates = async () => {
         setError(null);
         setIsLoading(true);
         try {
            const url = 'https://pt-api.digit-a.net/api/conversions';
            const response = await fetch(url);

            if (!response.ok) {
               throw new Error(`API Error: ${response.status}`);
            }

            const data = await response.json();
            setRates(data);
         } catch (error) {
            console.error("Could not load token prices.", error);
            setError("Real time data is not available at the moment. Please try again later.");
         } finally {
            setIsLoading(false);
         }
      };

      fetchRates();
   }, []);

   const getPrice = (tokenName, currencySymbol = '$', decimals = 2) => {
      if (isLoading) return 'Loading...';
      if (!rates || typeof rates[tokenName] === 'undefined') {
         return 'Not Available';
      }
      if (tokenName === 'PROPT') {
         return `${currencySymbol}${rates[tokenName].toFixed(2)}`;
      }
      return `${currencySymbol}${rates[tokenName].toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
   };

   return (
      <div className="container-fluid max py-lg-5" page-key="ProptTokens">
         {/* Cabecera común */}
         <nav class="navbar navbar-expand-lg p-0 mb-4 mb-lg-5">
            {error && (
               <div className="alert alert-danger" role="alert">
                  {error}
               </div>
            )}
            <div class="container-fluid px-0">
               <div className="row align-items-center w-100 mx-0" data-orders>
                  <div data-order="1" className="col col-lg-3 px-0">
                     <NavLink to="/dashboard" className="">
                        <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
                     </NavLink>
                  </div>
                  <div data-order="2" className="col-auto d-flex align-items-center gap-3 px-0">
                     <UserActionsBar />
                     <span className="d-lg-none" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <svg width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <rect x="0.577148" width="27.4231" height="3.53846" fill="var(--white)" />
                           <rect x="0.577148" y="9.73077" width="27.4231" height="3.53846" fill="var(--white)" />
                           <rect x="0.577148" y="19.4615" width="27.4231" height="3.53846" fill="var(--white)" />
                        </svg>
                     </span>
                  </div>
                  <div data-order="3" className="collapse navbar-collapse" id="navbarNavDropdown">
                     <div className="col">
                        <nav className="ppt_navdash">
                           <NavLink to="/dashboard" className="link">Wallet</NavLink>
                           <NavLink to="/propt-tokens" className="link">Propt Tokens</NavLink>
                           {/* <span className="link">Earn</span> */}
                           <NavLink to="/support" className="link">SUPPORT</NavLink>
                           <NavLink to="/settings" className="link d-lg-none">SETTINGS</NavLink>
                           <span className="link d-lg-none">
                              <LogoutButton />
                           </span>
                        </nav>
                     </div>
                  </div>
               </div>
            </div>
         </nav>
         {/* Contenido principal */}
         {/* Stablecoins - USDP */}
         <div className="row mb-4">
            <div className="col-12">
               <h3>Stablecoins</h3>
               <p className="mb-0">Stablecoins issued by ProperT LLC. Backed by real USD &amp; EUR at 1:1 ratio.</p>
            </div>
         </div>
         <div className="row mb-4">
            <div className="col-12">
               <div className="ppt_box_gen p-lg-4">
                  <div className="row align-items-center w-100">
                     <div className="col col-lg-auto d-flex align-items-center gap-3">
                        <div>
                           <img src="/assets/img/icon_propt_dollar.svg" alt="" />
                        </div>
                        <div>
                           <p className="mb-0">USDP</p>
                           <h4 className="mb-0">{getPrice('USDP')}</h4>
                        </div>
                     </div>
                     <div className="col d-none d-lg-flex ">
                        <p className="mb-0 px-4" style={{ fontSize: '15px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                     </div>
                     <div className="col col-lg-auto d-flex align-items-end align-items-lg-center gap-3 flex-column flex-lg-row px-0">
                        <span aria-current="page" className="ppt_btn_secondary alt" style={{ borderColor: '#fff!important' }}>Deposit USDP</span>
                        <span aria-current="page" className="ppt_btn_primary alt">Buy USDP</span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         {/* EURP Token */}
         <div className="row mb-5">
            <div className="col-12">
               <div className="ppt_box_gen p-lg-4">
                  <div className="row align-items-center w-100">
                     <div className="col col-lg-auto d-flex align-items-center gap-3">
                        <div>
                           <img src="/assets/img/icon_propt_euro.svg" alt="" />
                        </div>
                        <div>
                           <p className="mb-0">EURP</p>
                           <h4 className="mb-0">{getPrice('USDP')}</h4>
                        </div>
                     </div>
                     <div className="col d-none d-lg-flex ">
                        <p className="mb-0 px-4" style={{ fontSize: '15px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                     </div>
                     <div className="col col-lg-auto d-flex align-items-end align-items-lg-center gap-3 flex-column flex-lg-row px-0">
                        <span aria-current="page" className="ppt_btn_secondary alt" style={{ borderColor: '#fff!important' }}>Deposit EURP</span>
                        <span aria-current="page" className="ppt_btn_primary alt">Buy EURP</span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         {/* Rewards Tokens Header */}
         <div className="row mb-4">
            <div className="col-12">
               <h3>Rewards Tokens</h3>
               <p className="mb-0">Tokens issued by ProperT LLC that reward spending, enhance buying power, and provide exclusive incentives within the ProperT & ForumPay ecosystem.</p>
            </div>
         </div>
         {/* PROPT Token */}
         <div className="row mb-4">
            <div className="col-12">
               <div className="ppt_box_gen p-lg-4">
                  <div className="row align-items-center w-100">
                     <div className="col col-lg-auto d-flex align-items-center gap-3">
                        <div>
                           <img src="/assets/img/icon_propt_n.svg" alt="" />
                        </div>
                        <div>
                           <p className="mb-0">PROPT</p>
                           <h4 className="mb-0">{getPrice('PROPT')}</h4>
                        </div>
                     </div>
                     <div className="col d-none d-lg-flex ">
                        <p className="mb-0 px-4" style={{ fontSize: '15px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                     </div>
                     <div className="col col-lg-auto d-flex align-items-end align-items-lg-center gap-3 flex-column flex-lg-row px-0">
                        <span aria-current="page" className="ppt_btn_secondary alt" style={{ borderColor: '#fff!important' }}>Deposit PROPT</span>
                        <span aria-current="page" className="ppt_btn_primary alt">Buy PROPT</span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         {/* HOM Token */}
         <div className="row mb-5">
            <div className="col-12">
               <div className="ppt_box_gen p-lg-4">
                  <div className="row align-items-center w-100">
                     <div className="col col-lg-auto d-flex align-items-center gap-3">
                        <div>
                           <img src="/assets/img/icon_hom.png" alt="" style={{ width: '43px' }} />
                        </div>
                        <div>
                           <p className="mb-0">HOM</p>
                           <h4 className="mb-0">{getPrice('HOM')}</h4>
                        </div>
                     </div>
                     <div className="col d-none d-lg-flex ">
                        <p className="mb-0 px-4" style={{ fontSize: '15px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                     </div>
                     <div className="col col-lg-auto d-flex align-items-end align-items-lg-center gap-3 flex-column flex-lg-row px-0">
                        <span
                           aria-current="page"
                           className="ppt_btn_secondary alt"
                           style={{ borderColor: '#fff!important', cursor: 'pointer' }}
                        // onClick={() => handleDepositClick('HOM', 'HOM')}
                        >
                           Deposit HOM
                        </span>
                        <span
                           aria-current="page"
                           className="ppt_btn_primary alt"
                           style={{ cursor: 'pointer' }}
                        // onClick={() => handleBuyClick('HOM', 'HOM')}
                        >
                           Buy HOM
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         {/* Precious Metals Header */}
         <div className="row mb-4">
            <div className="col-12">
               <h3>Precious Metals</h3>
               <p className="mb-0">Tokens isseued by ProperT LLC that mirror the value of real precious metals per ounce, fully backed 1:1 by Fidelity ETFs.</p>
            </div>
         </div>
         {/* Gold Token */}
         <div className="row mb-4">
            <div className="col-12">
               <div className="ppt_box_gen p-lg-4">
                  <div className="row align-items-center w-100">
                     <div className="col col-lg-auto d-flex align-items-center gap-3">
                        <div>
                           <img src="/assets/img/icon_propt_gold.svg" alt="" />
                        </div>
                        <div>
                           <p className="mb-0">Gold Token</p>
                           <h4 className="mb-0">{getPrice('Oro')}</h4>
                        </div>
                     </div>
                     <div className="col d-none d-lg-flex ">
                        <p className="mb-0 px-4" style={{ fontSize: '15px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                     </div>
                     <div className="col col-lg-auto d-flex align-items-end align-items-lg-center gap-3 flex-column flex-lg-row px-0">
                        <span
                           aria-current="page"
                           className="ppt_btn_secondary alt"
                           style={{ borderColor: '#fff!important', cursor: 'pointer' }}
                        // onClick={() => handleDepositClick('GOLDT', 'GOLDT')}
                        >
                           Deposit GOLDT
                        </span>
                        <span
                           aria-current="page"
                           className="ppt_btn_primary alt"
                           style={{ cursor: 'pointer' }}
                        // onClick={() => handleBuyClick('GOLDT', 'GOLDT')}
                        >
                           Buy GOLDT
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         {/* Silver Token */}
         <div className="row mb-5">
            <div className="col-12">
               <div className="ppt_box_gen p-lg-4">
                  <div className="row align-items-center w-100">
                     <div className="col col-lg-auto d-flex align-items-center gap-3">
                        <div>
                           <img src="/assets/img/icon_propt_silver.svg" alt="" />
                        </div>
                        <div>
                           <p className="mb-0">Silver Token</p>
                           <h4 className="mb-0">{getPrice('Plata')}</h4>
                        </div>
                     </div>
                     <div className="col d-none d-lg-flex ">
                        <p className="mb-0 px-4" style={{ fontSize: '15px' }}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                     </div>
                     <div className="col col-lg-auto d-flex align-items-end align-items-lg-center gap-3 flex-column flex-lg-row px-0">
                        <span
                           aria-current="page"
                           className="ppt_btn_secondary alt"
                           style={{ borderColor: '#fff!important', cursor: 'pointer' }}
                        // onClick={() => handleDepositClick('SILVT', 'SILVT')}
                        >
                           Deposit SILVT
                        </span>
                        <span
                           aria-current="page"
                           className="ppt_btn_primary alt"
                           style={{ cursor: 'pointer' }}
                        // onClick={() => handleBuyClick('SILVT', 'SILVT')}
                        >
                           Buy SILVT
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         {/* Modales */}
         <DepositModal
            isOpen={isDepositModalOpen}
            onClose={() => {
               setIsDepositModalOpen(false);
               setInitialStep(1);
               setSelectedCrypto(null);
            }}
            initialStep={initialStep}
            initialCrypto={selectedCrypto}
         />
         <BuyModal
            isOpen={isBuyModalOpen}
            onClose={() => {
               setIsBuyModalOpen(false);
               setSelectedCryptoForBuy(null);
            }}
            cryptoType={selectedCryptoForBuy}
         />
      </div>
   );
};
export default ProptTokens;